export const environment = {
  production: false,
  env: 'staging',
  apiUrl: 'https://api-staging.caremessenger.co.uk/v2',
  signalingUrl: 'https://signal.bxthree.com',
  pusherKey: '2dd7fcb4e455b0869e43',
  ravenDsn: 'https://588f3cd1851c4b3e911855c54bc3dc0d@sentry.bxthree.com/44',
};
